module.exports = __webpack_public_path__ + "media/images/partner-12-8e22189b3f22f0e5069584489121abda.png";